"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorToolbar = void 0;
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const theme_palette_1 = require("../../components/theme.palette");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const page_1 = require("../../page/page");
const CSS = {
    container: 'c-TopologicalEditorToolbar',
    title: 'c-TopologicalEditorToolbarTitle',
    buttons: 'c-TopologicalEditorToolbarButtons',
    save: 'c-ButtonSaveAll'
};
const Style = {
    [CSS.container]: {
        padding: theme_1.DefaultTheme.space(2),
        backgroundColor: (0, theme_1.rgba)(theme_palette_1.ColorPaletteOrange.C100),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '120%',
        minHeight: theme_1.DefaultTheme.space(10),
        overflow: 'hidden'
    },
    [CSS.save]: {
        color: theme_1.DefaultTheme.color.accent
    },
    [CSS.title]: {
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    [CSS.buttons]: {
        display: 'flex'
    }
};
(0, theme_1.addStyles)(Style);
exports.TopologicalEditorToolbar = {
    saveButton(button) {
        if (button.isSaving) {
            return spinner_1.Spinner.view();
        }
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.DONE_ALL, {
            className: CSS.save,
            title: i18n_1.T.TOPO_SAVE_JOB,
            disabled: button.disabled,
            onclick: button.onClick
        });
    },
    returnButton(onClick) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.PHOTO_MEASURE, {
            title: i18n_1.T.LINK_PHOTOMEASURE,
            href: page_1.IkePageName.collectionMeasure,
            flip: true,
            disabled: false,
            onclick: onClick
        });
    },
    view(opts) {
        return (0, mithril_1.m)('header', {
            className: CSS.container
        }, [
            (0, mithril_1.m)('div', { className: CSS.title, title: opts.title }, opts.title),
            (0, mithril_1.m)('div', { className: CSS.buttons }, [
                opts.selectedCollectionData ? this.returnButton(opts.selectedCollectionData.onClick) : null,
                this.saveButton(opts.saveButton)
            ])
        ]);
    }
};
//# sourceMappingURL=topological.editor.toolbar.js.map